export const FETCH_SLIDERS_REQUEST = 'FETCH_SLIDERS_REQUEST';
export const FETCH_SLIDERS_SUCCESS = 'FETCH_SLIDERS_SUCCESS';
export const FETCH_SLIDERS_FAILURE = 'FETCH_SLIDERS_FAILURE';
